import React from 'react';
import { IconProps } from './model/IconInterface';

const UploadCloudIcon: React.FC<IconProps> = ({ size = 20, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox='0 0 24 24'
       fill='none' stroke={color}
       strokeWidth='1.8' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4' />
    <path d='M7 9l5-5 5 5' />
    <path d='M12 4v12' />
  </svg>
);

export default UploadCloudIcon;
